module.exports = __webpack_public_path__ + "media/homeProperty/Union-3cf71275.jpg";